import { LayoutGroup, motion } from "framer-motion";
import { useCallback, useState } from "react";
import { teamData } from "store/allData";
import { badgeType, teamMemberType } from "types/allTypes";
import MemberCard from "./MemberCard";
import LoadMore from "components/common/LoadMore";
import Heading from "components/common/Heading";
import SectionWrapper from "components/common/SectionWrapper";

interface props {
  shuffledTeam: teamMemberType[];
}

const Team: React.FC<props> = ({ shuffledTeam }) => {
  const [typeFilter, setTypeFilter] = useState("All");
  const [num, setNum] = useState(8);

  const filterClickHandler = useCallback((data: badgeType) => {
    setNum(teamData.length);
    setTypeFilter(data.name);
  }, []);

  const sortedTeamData = shuffledTeam
    .filter((el) => el)
    .sort((a, b) => {
      if (typeFilter === "" || typeFilter === "All") return 0;
      if (a.roleType.name === typeFilter) {
        return -1;
      } else {
        return 1;
      }
    });

  return (
    <SectionWrapper className="mx-auto">
      <div
        id="team"
        className="w-full mx-auto flex flex-col justify-center items-center py-24 relative scroll-mt-32"
      >
        <span className="eyebrow">The people</span>
        <Heading className="text-3xl sm:text-4xl mt-4 text-center">
          Our team
        </Heading>
        <p className="mt-4 max-w-xl text-center text-zinc-400">
          A tight senior crew — engineers, designers, and product minds who ship
          together.
        </p>
        <LayoutGroup>
          <motion.ul
            className="w-full grid gap-5 mt-12 justify-center"
            style={{ gridTemplateColumns: "repeat(auto-fit,283px)" }}
          >
            {sortedTeamData.map((data, index) => {
              if (index + 1 > num) return null;
              return <MemberCard key={data.id} data={data} index={index} />;
            })}
          </motion.ul>
        </LayoutGroup>
        <LoadMore
          className="absolute -bottom-5 z-100 "
          initial={6}
          addPerClick={6}
          num={num}
          fullLength={teamData.length}
          setNum={setNum}
        />
      </div>
    </SectionWrapper>
  );
};

export default Team;
